/**
 * Parse pasted vocabulary, per docs/UX.md §2: one pair per line, separated by
 * "=", ";", ":" or a tab. This is the fallback that must always work — if the
 * photo scan fails we drop straight into this, never into an error page.
 */
export interface ParsedPair {
  a: string;
  b: string;
}

export interface ParseLinesResult {
  pairs: ParsedPair[];
  /** 1-based line numbers we could not split into two halves. */
  skippedLines: number[];
}

const SEPARATORS = /\s*(?:\t|=|;|:|\s{2,}| - | – )\s*/;

export function parseLines(input: string): ParseLinesResult {
  const pairs: ParsedPair[] = [];
  const skippedLines: number[] = [];

  input.split(/\r?\n/).forEach((rawLine, index) => {
    const line = rawLine.trim();
    if (line.length === 0) return;

    const parts = line.split(SEPARATORS).map((part) => part.trim()).filter(Boolean);
    if (parts.length < 2) {
      skippedLines.push(index + 1);
      return;
    }
    // More than two parts means the second separator belongs to the answer
    // side ("Katze = cat; feline"). Keep the first split, rejoin the rest.
    const a = parts[0] as string;
    const b = parts.slice(1).join(" | ");
    pairs.push({ a, b });
  });

  return { pairs, skippedLines };
}
